
const HOTLIST_BASE = 'https://test.vdpl.co/api/index.php/'

export const getHostlistGroupNames = async () => {
  const response = await fetch(`${HOTLIST_BASE}/getHotlistGroups`, {
    method: "GET",
  });
  const data = await response.json();
      if (!response.ok || data?.success === false) {
        throw new Error(
          data?.error || data?.message || `Failed to load hotlist groups (${response.status})`,
        );
      }
      return data;
};

export const createHotlistGroup = async ({ name, action_by }) => {
  const body = new URLSearchParams();
  body.append("name", String(name ?? ""));
  body.append("action_by", String(action_by ?? ""));

  const response = await fetch(`${HOTLIST_BASE}/createHotlistGroup`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to create hotlist group");
  }
  return data;
};

export const updateHotListGroup = async ({ group_id, name, description = "" }) => {
  const body = new URLSearchParams();
  body.append("group_id", String(group_id ?? ""));
  body.append("name", String(name ?? ""));
  body.append("description", String(description ?? ""));

  const response = await fetch(`${HOTLIST_BASE}/updateHotListGroup`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to update hotlist group");
  }
  return data;
};

export const deleteHotlistGroup = async ({ group_id, action_by, user_id }) => {
  const body = new URLSearchParams();
  body.append("group_id", String(group_id ?? ""));
  body.append("action_by", String(action_by ?? ""));
  body.append("user_id", String(user_id ?? action_by ?? ""));

  const response = await fetch(`${HOTLIST_BASE}/deleteHotlistGroup`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to delete hotlist group");
  }
  return data;
};

export const getHostlistGroupCandidates = async (groupId) => {
  const body = new URLSearchParams();
  body.append("group_id", String(groupId ?? "").toString());

  const response = await fetch(`${HOTLIST_BASE}getHostlistGroupCandidates`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to load hotlist candidates");
  }
  return data;
};

export const addToHotlist = async ({
  candidate_id,
  name,
  group_name,
  description = "",
  notes = "",
  action_by,
}) => {
  const resolvedGroupName = String(name ?? group_name ?? "");
  const body = new URLSearchParams();
  body.append("candidate_id", String(candidate_id ?? ""));
  body.append("name", resolvedGroupName);
  body.append("group_name", resolvedGroupName);
  body.append("description", String(description ?? ""));
  body.append("notes", String(notes ?? ""));
  body.append("action_by", String(action_by ?? ""));

  const response = await fetch(`${HOTLIST_BASE}/addHotlistCandidate`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to add candidate to hotlist");
  }
  return data;
};

export const removeFromHotlist = async ({
  candidate_id,
  group,
  action_by,
  hard_delete = 1,
}) => {
  const body = new URLSearchParams();
  body.append("candidate_id", String(candidate_id ?? ""));
  body.append("group", String(group ?? ""));
  body.append("action_by", String(action_by ?? ""));
  body.append("hard_delete", String(1));

  const response = await fetch(`${HOTLIST_BASE}removeCandidateFromHotlist`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body.toString(),
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to remove candidate from hotlist");
  }
  return data;
};

export const triggerEmail = async ({
  email_id,
  email_cc_address = "",
  email_bcc_address = "",
  group_id,
  candidate_id = [],
  email_by,
  user_name,
  user_id,
  template_id = 1,
  send = 1,
  debug = 0,
  test_to = "",
}) => {
  const body = new URLSearchParams();
  body.append("email_id", String(email_id ?? "").trim());
  body.append("email_cc_address", String(email_cc_address ?? "").trim());
  body.append("email_bcc_address", String(email_bcc_address ?? "").trim());
  body.append("group_id", String(group_id ?? "").trim());
  body.append("template_id", String(template_id ?? 1));
  body.append("send", String(send ?? 1));
  body.append("debug", String(debug ?? 0));
  if (String(test_to ?? "").trim()) {
    body.append("test_to", String(test_to).trim());
  }
  const resolvedUserName = String(user_name ?? email_by ?? "").trim();
  body.append("email_by", resolvedUserName);
  body.append("user_name", resolvedUserName);
  body.append("user_id", String(user_id ?? "").trim());

  const candidateIdsArray = Array.isArray(candidate_id)
    ? candidate_id
      .map((id) => Number(id))
      .filter((id) => Number.isFinite(id) && id > 0)
    : [];
  body.append("candidate_id", JSON.stringify(candidateIdsArray));

  const response = await fetch(`${HOTLIST_BASE}triggerEmail`, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    body: body,
  });
  const data = await response.json();
  if (!response.ok || data?.success === false) {
    throw new Error(data?.error || data?.message || "Failed to send hotlist email");
  }
  return data;
};

